import ReceiptPage from "./ReceiptPage";

export default ReceiptPage;